module.exports = __webpack_public_path__ + "img/人参.d9918d0a.jpg";